import { ShieldCheck } from "lucide-react";
import { SECURITY } from "../data/content";
import { Icon, Overline } from "./Bits";
import { Reveal, Stagger, StaggerItem } from "./Reveal";

export function SecuritySection({ compact = false }) {
  return (
    <section
      className="relative overflow-hidden bg-navy-deep py-24 text-white md:py-32"
      data-testid="security-section"
    >
      <div className="grain absolute inset-0" />
      <div className="pointer-events-none absolute left-1/2 top-0 h-64 w-[40rem] -translate-x-1/2 rounded-full bg-gold/10 blur-3xl" />
      <div className="relative mx-auto max-w-7xl px-5 md:px-8">
        <div className="mx-auto max-w-2xl text-center">
          <Reveal>
            <span className="mx-auto inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/5 px-4 py-1.5 text-xs font-semibold uppercase tracking-[0.2em] text-gold">
              <ShieldCheck className="h-4 w-4" /> Trust & Security
            </span>
          </Reveal>
          <Reveal delay={0.08}>
            <h2 className="mt-6 font-heading text-4xl font-bold tracking-tight sm:text-5xl">
              Your generosity, <span className="italic text-gold">fully protected.</span>
            </h2>
          </Reveal>
          <Reveal delay={0.16}>
            <p className="mt-5 text-base leading-relaxed text-white/70">
              Every donation and every detail you share is handled with bank-grade security and a
              privacy-first commitment — so you can give with total confidence.
            </p>
          </Reveal>
        </div>

        <Stagger className="mt-16 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {SECURITY.map((s) => (
            <StaggerItem key={s.title}>
              <div className="flair-card group h-full rounded-2xl border border-white/10 bg-white/[0.03] p-7">
                <span className="flair-icon grid h-12 w-12 place-items-center rounded-full bg-gold/12 text-gold ring-1 ring-gold/25">
                  <Icon name={s.icon} className="h-5 w-5" />
                </span>
                <h3 className="mt-6 font-heading text-lg font-semibold">{s.title}</h3>
                <p className="mt-2.5 text-sm leading-relaxed text-white/65">{s.text}</p>
              </div>
            </StaggerItem>
          ))}
        </Stagger>

        {!compact && (
          <Reveal delay={0.1}>
            <p className="mx-auto mt-12 max-w-2xl text-center text-xs leading-relaxed text-white/45">
              Donations are processed securely by Stripe, one of the world's most trusted payment
              providers. Your card details never touch our servers — ever.
            </p>
          </Reveal>
        )}
      </div>
    </section>
  );
}
